<template>
  <div class="">
    <Tabs  type="card">
      <TabPane label="基础信息" name="baseInfo">
        <keep-alive>
          <base-update :projectFid="projectFid"></base-update>
        </keep-alive>
      </TabPane>

      <TabPane label="楼栋信息" name="buildInfo">
        <keep-alive>
          <build-update :projectFid="projectFid"></build-update>
        </keep-alive>
      </TabPane>
      <TabPane label="房型信息" name="typeInfo">
        <keep-alive>
          <type-update :projectFid="projectFid"></type-update>
        </keep-alive>
      </TabPane>
      <TabPane label="项目资料" name="projectInfo">
        <keep-alive>
          <info-update @showimg="showImg" :projectFid="projectFid"></info-update>
        </keep-alive>
      </TabPane>
    </Tabs>
    <img-show :src="imgShowSrc" :n="imgShowN"></img-show>
  </div>
</template>

<script>
  import ImgShow from 'components/ImgShow/index';
  import BaseUpdate from './components/BaseUpdate';
  import RunUpdate from './components/RunUpdate';
  import BuildUpdate from './components/BuildUpdate';
  import TypeUpdate from './components/TypeUpdate';
  import InfoUpdate from './components/InfoUpdate'

  export default {
    name: "updateProjectInfo",
    components:{
      ImgShow,
      BaseUpdate,
      RunUpdate,
      BuildUpdate,
      TypeUpdate,
      InfoUpdate,
      // RunUpdate:import('./components/RunUpdate'),
      // BuildUpdate:import( './components/BuildUpdate'),
    },
    data(){
      return {
        conditionList:{},
        projectFid:'',
        projectInfos:[
          {key:'runQualificate',text:'经营资质'},{key:'contractFile',text:'合同附件'},
          {key:'enginFile',text:'工程材料'},{key:'others',text:'其他'}
        ],
        currentInfo:'baseInfo',
        baseInfoData:{
        },
        imgShowSrc:'',
        imgShowN:0,
      }
    },
    methods:{
      showImg(src){
        this.imgShowSrc=src
        this.imgShowN++
      }
    },
    created(){
      this.projectFid=this.$route.params.id
    }
  }
</script>

<style scoped>
  .content {
    padding: 30px 20px;
    box-sizing: border-box;
  }

</style>
